export * from "./config.js"

export const EVENT_TYPE = {
  INSTANT: "instant",
  REALTIME: "realTime",
}

export const CUSTOM_EVENT = {
  BATCH_CREATED: "batchCreated",
  BATCH_FAILED: "batchFailed",
}

export const TICK_TIME = 1000
